import React, {useEffect, useState} from 'react';

import {useDispatch, useSelector} from "react-redux";

import {makeStyles} from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";

import {Select} from "../../components/tools/SelectorOrText/Select";
import {ProfileMenuContainer} from "../ProfileMenuContainer/ProfileMenuContainer";
import {getProfile} from "../../redux/reducers/user-profile-reducer.js";


import {loadingContracts, selectContracts, setSelectedContract} from "../../redux/reducers/contract-reducer";
import {getProjects, loadingProjects, setSelectedProject} from "../../redux/reducers/project-reducer";
import {Header} from "../../components/Header/Header";


const useStyles = makeStyles((theme) => ({
    selectOption: {
        backgroundColor: theme.palette.common.white,
        width: 175
    },
    selectOutlined: {
        padding: '8.5px 35px 8.5px 10px'
    }
}))


export const ContractProjectHeader = () => {
    const classes = useStyles()
    
    const {user} = useSelector(getProfile)

    const {contracts, selectedContract} = useSelector(selectContracts)
    const {projects, selectedProject, loading: projectLoading} = useSelector(getProjects)
    const [isContractor, setIsContractor] = useState(false)



    const dispatch = useDispatch()
    useEffect(() => {
        setIsContractor(user?.role === 'contractor'?true:false)
    }, [user])

    const handleProjectSelector = (e) => {
        dispatch(setSelectedProject(projects.filter(f => f.id === e.target.value)[0]))
    }

    const handleContractSelector = (e) => {
        dispatch(setSelectedProject(null))
        dispatch(setSelectedContract(contracts.filter(f => f.id === e.target.value)[0]))
    }
    useEffect(() => {
        dispatch(loadingContracts)
    }, [])

    useEffect(() => {
        if (selectedContract?.id) {
            dispatch(loadingProjects(selectedContract?.id))
        }
    }, [dispatch, selectedContract])


    return <Header>
        <Select data={contracts}
                formControlProps={{variant: 'outlined'}}
                selectProps={
                            {
                                className: classes.selectOption,
                                classes: {
                                    outlined: classes.selectOutlined
                                }
                            }
                        }
                uniqueKey={'header-project'}
                value={selectedContract?.id}
                onChange={handleContractSelector}
        />
        {isContractor ? null : projectLoading || projects.length === 0?
            <Skeleton variant="rect" width={175} height={36}/>
            :
            <Select data={projects}
                    formControlProps={{variant: 'outlined'}}
                    selectProps={
                                {
                                    className: classes.selectOption,
                                    classes: {
                                        outlined: classes.selectOutlined
                                    }
                                }
                            }
                    value={selectedProject?.id}
                    onChange={handleProjectSelector}
                    uniqueKey={'act-picker'}
            />
        }
        <ProfileMenuContainer/>
    </Header>
}